export const rcvDetailModel = (id) => ({
    id: id,
    rcvDId: null,
    rcvId: null,
    invId: null,
    line: null,
    itemDesc: null,
    itemPrice: null,
    itemDiscount: null,
    itemDisType: null,
    itemTotal: null,
    itemStatus: null,
    dsSeq: null
});
